import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiEye, FiCopy, FiCheck } = FiIcons;

const ColorPicker = ({ colors, onChange }) => {
  const [copiedColor, setCopiedColor] = useState(null);

  const colorLabels = {
    primary: 'Primary',
    secondary: 'Secondary', 
    accent: 'Accent',
    background: 'Background',
    text: 'Text'
  };

  const handleColorChange = (colorKey, value) => {
    onChange(colorKey, value);
  };

  const copyToClipboard = (color) => {
    navigator.clipboard.writeText(color);
    setCopiedColor(color);
    setTimeout(() => setCopiedColor(null), 2000);
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Brand Colors</h3>
        <p className="text-gray-600 mb-6">Define your brand's color palette</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.entries(colors).map(([key, color]) => (
          <div key={key} className="space-y-3">
            <label className="block text-sm font-medium text-gray-700">
              {colorLabels[key]} Color
            </label>
            
            <div className="flex items-center space-x-3">
              <div className="relative">
                <input
                  type="color"
                  value={color}
                  onChange={(e) => handleColorChange(key, e.target.value)}
                  className="w-12 h-12 rounded-lg border-2 border-gray-300 cursor-pointer"
                />
              </div>
              
              <div className="flex-1">
                <input
                  type="text"
                  value={color}
                  onChange={(e) => handleColorChange(key, e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-mono text-sm"
                  placeholder="#000000"
                />
              </div>
              
              <button
                onClick={() => copyToClipboard(color)}
                className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                title="Copy color"
              >
                <SafeIcon 
                  icon={copiedColor === color ? FiCheck : FiCopy} 
                  className={`w-4 h-4 ${copiedColor === color ? 'text-green-600' : ''}`} 
                />
              </button>
            </div>
            
            <div 
              className="w-full h-16 rounded-lg border-2 border-gray-300"
              style={{ backgroundColor: color }}
            />
          </div>
        ))}
      </div>

      {/* Color Palette Preview */}
      <div className="mt-8 p-6 bg-gray-50 rounded-lg">
        <h4 className="text-md font-semibold text-gray-900 mb-4">Palette Preview</h4>
        <div className="flex space-x-2">
          {Object.entries(colors).map(([key, color]) => (
            <div key={key} className="text-center">
              <div 
                className="w-16 h-16 rounded-lg border-2 border-white shadow-sm mb-2"
                style={{ backgroundColor: color }}
              />
              <p className="text-xs text-gray-600 capitalize">{key}</p>
              <p className="text-xs text-gray-500 font-mono">{color}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;